function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { variables } from 'swag-client-common/styles/variables-js';
import classes from './info-icon.scss';
const infoIconStyles = {
  fontSizeSmall: classes.fontSizeSmall
};
const InfoIcon = props => {
  const {
      classes,
      iconColor,
      isLimitedEdition
    } = props,
    rest = _objectWithoutProperties(props, ["classes", "iconColor", "isLimitedEdition"]);
  const color = isLimitedEdition ? variables.colorOrange : iconColor || variables.colorPrimary;
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    classes: _objectSpread({}, infoIconStyles, classes)
  }, rest, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Build-A-Box",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-to-box-checkout",
    transform: "translate(-713.000000, -1099.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: "0",
    y: "0",
    width: "1920",
    height: "2985"
  }), /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/information",
    transform: "translate(714.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: "8",
    cy: "8",
    r: "8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93333333,6.4 L8,6.4 L8,12.2666667 M6.93333333,12.2688 L9.06666667,12.2688",
    id: "Shape",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: color,
    cx: "7.71111111",
    cy: "4",
    r: "1"
  }))))));
};
export default InfoIcon;